import styled from 'styled-components'
import { spacing } from '@chegg-ui/theme'

export { FeedbackCardsContainer as GrammarCardsContainer } from '../../styled'

export const GrammarSectionWrapper = styled.div`
  margin-top: ${spacing.px16};
`
